export const DEFAULT_FONT_SIZE = 14;

export const DEFAULT_FONT_FAMILY = "";
// Remove whitespace from colors so that equality comparison works for them
export function removeWhitespaceFromColor( colorItem ) {
	if ( !colorItem || !colorItem.color ) {
		return colorItem;
	}
	colorItem.color = colorItem.color.replace( /\s/g, '' );
	return colorItem;
}

export function showFakeVisualSelection( model, visualSelectionMarkerName ) {

	model.change( writer => {
		const range = model.document.selection.getFirstRange();

		if ( model.markers.has( visualSelectionMarkerName ) ) {
			writer.updateMarker( visualSelectionMarkerName, { range } );
		} else {
			if ( range.start.isAtEnd ) {
				const startPosition = range.start.getLastMatchingPosition(
					( { item } ) => !model.schema.isContent( item ),
					{ boundaries: range }
				);

				writer.addMarker( visualSelectionMarkerName, {
					usingOperation: false,
					affectsData: false,
					range: writer.createRange( startPosition, range.end )
				} );
			} else {
				writer.addMarker( visualSelectionMarkerName, {
					usingOperation: false,
					affectsData: false,
					range
				} );
			}
		}
	} );

}

export function hideFakeVisualSelection( model, visualSelectionMarkerName ) {

	if ( model.markers.has( visualSelectionMarkerName ) ) {
		model.change( writer => {
			writer.removeMarker( visualSelectionMarkerName );
		} );
	}
}

export function makeSelectionHighlighter( editor, visualSelectionMarkerName) {

	editor.conversion.for( 'editingDowncast' ).markerToHighlight( {
		model: visualSelectionMarkerName,
		view: {
			classes: [ 'ck-fake-font-selection' ]
		}
	} );

	editor.conversion.for( 'editingDowncast' ).markerToElement( {
		model: visualSelectionMarkerName,
		view: {
			name: 'span',
			classes: [ 'ck-fake-font-selection']
		}
	} );

}
